(function () {
  var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
  var client;
  var queue = [];
  var scriptLoading = false;

  var sharedOptions = {
    "product": {
      "styles": {
        "product": {
          "margin-top": "25px",
          "padding-bottom": "35px",
          "@media (min-width: 601px)": {
            "max-width": "calc(25% - 20px)",
            "margin-left": "20px",
            "padding-bottom": "65px"
          }
        },
        "title": { "font-family": "\"Helvetica Neue\", Helvetica, Arial, sans-serif", "font-weight": "normal", "color": "#ffffff" },
        "button": {
          "font-family": "\"Helvetica Neue\", Helvetica, Arial, sans-serif",
          "font-weight": "bold",
          "font-size": "16px",
          "padding-top": "16px",
          "padding-bottom": "16px",
          "color": "#2b2b2b",
          ":hover": { "color": "#2b2b2b", "background-color": "#dea625" },
          "background-color": "#f7b829",
          ":focus": { "background-color": "#dea625" },
          "border-radius": "40px",
          "padding-left": "95px",
          "padding-right": "95px"
        },
        "quantityInput": { "font-size": "16px", "padding-top": "16px", "padding-bottom": "16px" },
        "price": { "font-family": "\"Helvetica Neue\", Helvetica, Arial, sans-serif", "color": "#ffffff" },
        "compareAt": { "font-family": "\"Helvetica Neue\", Helvetica, Arial, sans-serif", "color": "#ffffff" },
        "unitPrice": { "font-family": "\"Helvetica Neue\", Helvetica, Arial, sans-serif", "color": "#ffffff" }
      },
      "buttonDestination": "onlineStore",
      "contents": { "options": false },
      "width": "580px",
      "text": { "button": "View product" }
    },
    "productSet": {
      "styles": { "products": { "@media (min-width: 601px)": { "margin-left": "-20px" } } }
    },
    "modalProduct": {
      "contents": { "img": false, "imgWithCarousel": true },
      "styles": {
        "product": {
          "@media (min-width: 601px)": { "max-width": "100%", "margin-left": "0px", "margin-bottom": "0px" }
        },
        "button": {
          "font-family": "\"Helvetica Neue\", Helvetica, Arial, sans-serif",
          "font-weight": "bold",
          "font-size": "16px",
          "padding-top": "16px",
          "padding-bottom": "16px",
          "color": "#2b2b2b",
          ":hover": { "color": "#2b2b2b", "background-color": "#dea625" },
          "background-color": "#f7b829",
          ":focus": { "background-color": "#dea625" },
          "border-radius": "40px",
          "padding-left": "95px",
          "padding-right": "95px"
        },
        "quantityInput": { "font-size": "16px", "padding-top": "16px", "padding-bottom": "16px" },
        "title": { "font-family": "\"Helvetica Neue\", Helvetica, Arial, sans-serif", "font-weight": "bold", "font-size": "26px", "color": "#ffffff" },
        "price": { "font-family": "\"Helvetica Neue\", Helvetica, Arial, sans-serif", "font-weight": "normal", "font-size": "18px", "color": "#ffffff" },
        "compareAt": { "font-family": "\"Helvetica Neue\", Helvetica, Arial, sans-serif", "font-weight": "normal", "font-size": "15.3px", "color": "#ffffff" },
        "unitPrice": { "font-family": "\"Helvetica Neue\", Helvetica, Arial, sans-serif", "font-weight": "normal", "font-size": "15.3px", "color": "#ffffff" },
        "description": { "color": "#ffffff" }
      },
      "text": { "button": "Add to cart" }
    },
    "modal": { "styles": { "modal": { "background-color": "#2b2b2b" } } },
    "option": { "styles": { "label": { "color": "#ffffff" } } },
    "cart": {
      "styles": {
        "button": {
          "font-family": "\"Helvetica Neue\", Helvetica, Arial, sans-serif",
          "font-weight": "bold",
          "font-size": "16px",
          "padding-top": "16px",
          "padding-bottom": "16px",
          "color": "#2b2b2b",
          ":hover": { "color": "#2b2b2b", "background-color": "#dea625" },
          "background-color": "#f7b829",
          ":focus": { "background-color": "#dea625" },
          "border-radius": "40px"
        }
      },
      "text": { "total": "Subtotal", "button": "Checkout" },
      "popup": false
    },
    "toggle": {
      "styles": {
        "toggle": {
          "font-family": "\"Helvetica Neue\", Helvetica, Arial, sans-serif",
          "font-weight": "bold",
          "background-color": "#f7b829",
          ":hover": { "background-color": "#dea625" },
          ":focus": { "background-color": "#dea625" }
        },
        "count": { "font-size": "16px", "color": "#2b2b2b", ":hover": { "color": "#2b2b2b" } },
        "iconPath": { "fill": "#2b2b2b" }
      }
    }
  };

  function getClient() {
    if (!client) {
      client = ShopifyBuy.buildClient({
        domain: 'cipher-spaces.myshopify.com',
        storefrontAccessToken: 'afb528d35d3464fd3d3a38f5f302c4f6'
      });
    }
    return client;
  }

  function renderComponent(productHandle, nodeId) {
    ShopifyBuy.UI.onReady(getClient()).then(function (ui) {
      ui.createComponent('product', {
        handle: productHandle,
        node: document.getElementById(nodeId),
        moneyFormat: 'Rs.%20%7B%7Bamount%7D%7D',
        options: sharedOptions
      });
    });
  }

  function loadScriptOnce() {
    if (scriptLoading || (window.ShopifyBuy && window.ShopifyBuy.UI)) return;
    scriptLoading = true;
    var script = document.createElement('script');
    script.async = true;
    script.src = scriptURL;
    (document.head || document.body).appendChild(script);
    script.onload = function () {
      queue.forEach(function (args) { renderComponent(args[0], args[1]); });
      queue = [];
    };
  }

  // Kept for manual/advanced use, e.g. calling from a custom section's own script.
  window.cipherLoadProduct = function (productHandle, nodeId) {
    if (window.ShopifyBuy && window.ShopifyBuy.UI) {
      renderComponent(productHandle, nodeId);
    } else {
      queue.push([productHandle, nodeId]);
      loadScriptOnce();
    }
  };

  // Auto-scan mode: finds <div data-cipher-product-handle="..."> anywhere on the page
  // and renders into it directly. No inline <script> tag needed in blog content,
  // so no ordering dependency on this file having loaded first.
  // NOTE: uses a "cipher-" prefixed attribute specifically so it can never collide
  // with the theme's own product card markup (which uses data-product-handle).
  function initEmbeds() {
    var els = document.querySelectorAll('[data-cipher-product-handle]:not([data-cipher-initialized])');
    els.forEach(function (el) {
      el.setAttribute('data-cipher-initialized', 'true');
      if (!el.id) {
        el.id = 'cipher-product-' + Math.random().toString(36).slice(2, 10);
      }
      window.cipherLoadProduct(el.getAttribute('data-cipher-product-handle'), el.id);
    });
  }

  // This file loads with `defer`, so the DOM is already fully parsed by the
  // time this line runs — safe to scan immediately.
  initEmbeds();

  // Exposed in case blog content is ever injected later (apps, AJAX, infinite scroll).
  window.cipherRescanProducts = initEmbeds;
})();